import EventEmitter from "events";

export default class Input extends EventEmitter {
  constructor(target) {
    super();

    this.mouseDown = false;
    this.target = target;

    this.mouseStartX = 0;
    this.mouseStartY = 0;
    this.deltaMouseX = 0;
    this.deltaMouseY = 0;

    this.mouseDownHandler = this.onMouseDown.bind(this);
    this.mouseUpHandler = this.onMouseUp.bind(this);
    this.mouseMoveHandler = this.onMouseMove.bind(this);
    this.mouseOutHandler = this.onMouseOut.bind(this);
    this.touchMoveHandler = this.onTouchMove.bind(this);
    this.touchStartHandler = this.onTouchStart.bind(this);

    target.addEventListener("mousedown", this.mouseDownHandler, false);
    target.addEventListener("touchstart", this.touchStartHandler, false);
    target.addEventListener("touchmove", this.touchMoveHandler, false);
  }

  onMouseDown(event) {
    this.target.addEventListener("mousemove", this.mouseMoveHandler, false);
    document.addEventListener("mouseup", this.mouseUpHandler, false);
    this.target.addEventListener("mouseout", this.mouseOutHandler, false);

    if (event.button === 0) {
      this.mouseStartX = event.clientX;
      this.mouseStartY = event.clientY;
      this.mouseDown = true;

      var rect = this.target.getBoundingClientRect();
      this.emit(
        "mousedown",
        this.mouseStartX - rect.left,
        this.mouseStartY - rect.top
      );
    }
  }

  onMouseMove(event) {
    this.deltaMouseX = event.clientX - this.mouseStartX;
    this.deltaMouseY = event.clientY - this.mouseStartY;

    this.mouseStartX = event.clientX;
    this.mouseStartY = event.clientY;

    this.emit("mousemove", this.deltaMouseX, this.deltaMouseY);
  }

  onMouseUp(event) {
    this.target.removeEventListener("mousemove", this.mouseMoveHandler, false);
    document.removeEventListener("mouseup", this.mouseUpHandler, false);
    this.target.removeEventListener("mouseout", this.mouseOutHandler, false);

    var rect = this.target.getBoundingClientRect();
    this.emit("mouseup", event.clientX - rect.left, event.clientY - rect.top);

    this.mouseDown = false;
  }

  onMouseOut(event) {
    this.target.removeEventListener("mousemove", this.mouseMoveHandler, false);
    document.removeEventListener("mouseup", this.mouseUpHandler, false);
    this.target.removeEventListener("mouseout", this.mouseOutHandler, false);
  }

  onTouchStart(event) {
    if (event.touches.length == 1) {
      event.preventDefault();
      event.stopPropagation();

      this.mouseStartX = event.touches[0].clientX;
      this.mouseStartY = event.touches[0].clientY;

      var rect = this.target.getBoundingClientRect();

      this.emit(
        "mousedown",
        this.mouseStartX - rect.left,
        this.mouseStartY - rect.top
      );
    }
  }

  onTouchMove(event) {
    if (event.touches.length == 1) {
      event.preventDefault();
      event.stopPropagation();

      this.deltaMouseX = event.touches[0].clientX - this.mouseStartX;
      this.deltaMouseY = event.touches[0].clientY - this.mouseStartY;

      this.mouseStartX = event.touches[0].clientX;
      this.mouseStartY = event.touches[0].clientY;

      this.emit("mousemove", this.deltaMouseX, this.deltaMouseY);
    }
  }
}
